import { IDataTableContextMenuEvent, ISelectItem } from "winfakt-vue-components";
import { BrowseStateBase } from "./browse-state-base";

export class BrowseContextMenuState {
	private state:BrowseStateBase;

	mouseX:number = 0;
	mouseY:number = 0;
	item:any = null;
	private _opened:boolean = false;
	public get opened():boolean {
		return this._opened;
	}
	items:ISelectItem<string | Function>[] = [];

	public constructor(state:BrowseStateBase){
		this.state = state;
	}


	onContextMenuClick(event:IDataTableContextMenuEvent, selectedItems:any[]) {
		if (this.opened) {
			this._opened = false;
			return;
		}
		if (event.item == null && selectedItems.length == 0) {
			return;
		}
		this.mouseX = event.event.pageX;
		this.mouseY = event.event.pageY;
		this.item = event.item;
		this._opened = true;
		this.state.emit("context-menu-item", event.item);
	}

	trigger(value:string){
		this._opened = false;
		this.state.emit("context-menu-trigger", {value, item: this.item});
	}

	close(){
		this._opened = false;
		this.state.emit("context-menu-item", null);
	}
}